export default "__VITE_ASSET__zG2IYNln__"